module.exports = __webpack_public_path__ + "static/media/icon3.e3e19957.svg";